// Module
var code = `<div data-bind="with: request">
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label for="Urgency" data-bind="label: 'cc_Ticket_Number'">Ticket number</label>
        <p class="form-control-static" data-bind="text: request_id"></p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label for="Impact" data-bind="label: 'cc_Creation_Date'">Creation Date</label>
        <p class="form-control-static" data-bind="text: formattedcreated_dttm"></p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label data-bind="label: 'cStatus'">Status</label>
        <div>
          <!-- ko ifnot: status() == 'CL' -->
          <!-- ko ifnot: isEscalated() && escalation_status() != 'RESOLVED' -->
          <button
            type="button"
            class="btn btn-default btn-md pull-right"
            style="line-height: 16px; height: 34px"
            data-bind="click: \$component.escalate, label: 'cc_Escalate', enable:!\$component.actionsAndEscaledDisabled"
          >
            Escalate
          </button>
          <!-- /ko -->
          <!-- /ko -->
          <div class="input-group" style="margin-right: 85px">
            <p
              class="form-control-static"
              data-bind="lookupDescription: { lookup: \$parent.lookup, name: 'REQ_STATUS', value: req_status }"
            ></p>
            <!-- ko if: canInteract -->
            <div class="input-group-btn" xstyle="padding-top: 10px;">
              <button
                type="button"
                class="btn btn-default dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bind="enable:!\$component.actionsAndEscaledDisabled"
              >
                <span data-bind="label: 'CAction'">Action</span>
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu dropdown-menu-right">
                <li>
                  <a href="#" data-bind="click: \$component.changeToCancel, label: 'Cancel'">Cancel</a>
                </li>
                <li>
                  <a href="#" data-bind="click: \$component.changeToClose, label: 'cc_Close'">Close</a>
                </li>
              </ul>
            </div>
            <!-- /ko -->

            <!-- ko if: isCompleted -->
            <div class="input-group-btn" xstyle="padding-top: 10px;">
              <button
                type="button"
                class="btn btn-default"
                data-bind="click: \$component.reOpen, label: 'cc_P_CAPITAL_REOPEN'"
              >
                REOPEN
              </button>
            </div>
            <!-- /ko -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label for="Urgency" data-bind="label: 'cc_Owner'">Owner</label>
        <p
          class="form-control-static"
          data-bind="lookupDescription: { lookup: \$parent.lookup, name: 'PLACEPERSONS', value: created_by }"
        ></p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label for="Impact" data-bind="label: 'cc_Current_Queue'">Current Queue</label>
        <p
          class="form-control-static"
          data-bind="lookupDescription: { lookup: \$parent.lookup, name: 'REQ_GROUP', value: req_group }"
        ></p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label data-bind="label: 'Priority'">Priority</label>

        <!-- ko ifnot: canInteract -->
        <p
          class="form-control-static"
          data-bind="lookupDescription: { lookup: \$parent.lookup, name: 'C_PRIOIMPACTURGENCY', value: user_def8 }"
        ></p>
        <!-- /ko -->
        <!-- ko if: canInteract -->
        <div class="input-group">
          <select
            class="form-control"
            data-bind="options: \$component.Priorities, optionsText: 'description', optionsValue: 'code_value', value: user_def8"
          ></select>
          <div class="input-group-btn" xstyle="padding-top: 10px;">
            <button
              type="button"
              class="btn btn-default"
              data-bind="click: \$component.updatePriority, enable: user_def8() != originalPriority(), label: 'cc_P_UPDATE'"
            >
              Update
            </button>
          </div>
        </div>
        <!-- /ko -->
      </div>
    </div>
  </div>
</div>
<escalate-control params="show: showEscalation, request: \$component.request"></escalate-control>
<change-status-control
  params="show: showChangeStatus, request: request, isIncidentRequest: true"
></change-status-control>
`;
// Exports
module.exports = code;